import ReportFinalized from '../components/Report/Finalized'
import ReportFinalizedList from '../components/Report/FinalizedList'
import ReportRealtime from '../components/Report/Realtime'

export default [
  {
    path: '/client/report/finalized',
    name: 'report-finalized',
    component: ReportFinalized,
    meta: {
      sideMenuId: 'report-finalized',
    },
  },
  {
    path: '/client/report/finalized/list',
    name: 'report-finalized-list',
    component: ReportFinalizedList,
    meta: {
      sideMenuId: 'report-finalized-list',
    },
  },
  {
    path: '/client/report/news-realtime',
    name: 'report-realtime',
    component: ReportRealtime,
    props: true,
    meta: {
      sideMenuId: 'report-realtime',
    },
  },
]
